import { IAppState } from '../common/state';

export function configSelector(state: IAppState) {
  return state.config;
}
